import { render, staticRenderFns } from "./Workcentre.vue?vue&type=template&id=1166a068&"
import script from "./Workcentre.vue?vue&type=script&lang=js&"
export * from "./Workcentre.vue?vue&type=script&lang=js&"
import style0 from "./Workcentre.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports